export default "__VITE_ASSET__213d1c59__"